// extracted by mini-css-extract-plugin
module.exports = {"succeedMessageStyle":"_2lBAXIvZ2thzyHgjrr6ZYJ"};